import { useContext } from 'react'

import { updateObject } from 'data/hooks/objects/objectOperations'
import { invalidateViews } from 'data/hooks/views'
import { PathContext } from 'features/utils/PathContext'
import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'

import { IconNameVariantType } from 'ui/components/Icon/Icon'
import { useToast } from 'ui/components/Toast'

export function useDetailViewExperienceSwitcherState() {
    // The object is not available in the path context in the new editor.
    const { object: pathObject } = useContext(PathContext)
    const { object: editorObject } = useLayoutEditorContext()
    const object = editorObject || pathObject

    const showButton = !!object

    const isTurboExperience = !!object?.options?.has_turbo_detail_view

    const toast = useToast()

    const onClick = async () => {
        if (!object) return

        const newState = isTurboExperience ? false : true
        try {
            await updateObject(
                object._sid,
                {
                    options: {
                        ...object.options,
                        has_turbo_detail_view: newState,
                    },
                },
                { allowOptimisticUpdates: false }
            )
            invalidateViews(object.stack_id)

            toast({
                type: 'success',
                title: 'Detail view experience updated successfully',
                startIcon: {
                    name: 'CheckCircle',
                },
                showDismissButton: true,
            })
        } catch {
            toast({
                type: 'error',
                title: 'There was a problem updating the detail view experience',
                helperText: 'Please try again later. If the issue persists, contact support.',
            })
        }
    }

    const label = isTurboExperience ? 'Revert to old experience' : 'Use new experience'
    const icon: IconNameVariantType | undefined = isTurboExperience
        ? undefined
        : { name: 'Sparkles' }

    return {
        showButton,
        onClick,
        label,
        icon,
    }
}
